class TermsConditions extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        const findLink = new Set();
        const links = document.querySelectorAll('terms-conditions a');

        for (let i = links.length - 1; i >= 0; i--) {
            const link = links[i];
            const href = link.href;

            if (findLink.has(href)) {
                link.setAttribute('href','#');
                link.addEventListener('click', (event) => {
                    event.preventDefault();
                    window.location.href = href;
                });
                link.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter') {
                        window.location.href = href;
                    }
                });
            } else {
                findLink.add(href);
            }
        }
    }
}

customElements.define('terms-conditions', TermsConditions)